import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { MachineGroupBuilder } from '../../models/builders/machine-group.builder';
import { getErrorHandlingOptions } from '../base/headers';
import { MachineGroup } from '../../models/machine-group';
import { MachineGroupCalendarDayBuilder } from '../../models/builders/machine-group-calendar-day.builder';
import { valueOf } from '../../utils/string.utils';

const machineGroupBody = (machineGroup: MachineGroup) => ({
  name: machineGroup.name
});

@Injectable()
export class MachineGroupApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }working-model-groups`;
  }

  getMachineGroups() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(MachineGroupBuilder.fromList)
      );
  }

  getActiveMachineGroups() {
    return this.httpClient.get(`${ this.apiUrl }/active`, getErrorHandlingOptions())
      .pipe(
        map(MachineGroupBuilder.fromList)
      );
  }

  getMachineGroup(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(MachineGroupBuilder.fromJson)
      );
  }

  getMachineGroupCalendarDays(hash: string, year: number) {

    const params = new HttpParams().append('year', valueOf(year));

    return this.httpClient.get(`${ this.apiUrl }/${ hash }/calendar-days`, { params })
      .pipe(
        map(MachineGroupCalendarDayBuilder.fromList)
      );
  }

  createMachineGroup(machineGroup) {
    return this.httpClient.post(this.apiUrl, machineGroupBody(machineGroup))
    .pipe(map(MachineGroupBuilder.fromJson));
  }

  updateMachineGroup(machineGroup: MachineGroup) {
    return this.httpClient.put(`${ this.apiUrl }/${ machineGroup.hash }`, machineGroupBody(machineGroup));
  }

  deleteMachineGroup(machineGroup: MachineGroup) {
    return this.httpClient.delete(`${ this.apiUrl }/${ machineGroup.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/machine-group-api.service.ts